import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { callApi } from "../../utils/api";
import { ADMIN_ROLE, FRONTOFFICE_ROLE } from "../../utils/role";

const Sidebar = () => {
  const [state, setState] = useState({
    openFileMenu: false,
    toggleCompletedFiles: false,
    toggleVettingFiles: false,
    openExternalMenu: false,
    openComplaintMenu: false,
    openNotificationMenu: false,
    openVisitorsMenu: false,
    openReportsMenu: false,
    externalLinks: [],
    pageDynamic: [],
    is_thread_mail_enabled: false,
    waiting_queue_count: 0,
    queue_count: 0,
    autoAssign: [{ id: "1", module_name: "Auto Assign", status: true }],
    file_grade: 0,
    verifyEmergentCount: 0,
    finalApprovalEmergentCount: 0,
    finalApprovalNormalFile: 0,
    dverifyEmergentCount: 0,
    dverifyNormalFile: 0,
    deviationfiles: 0,
    deviationemergentFile: 0,
    rectificationfiles: 0,
    rectificationemergentFile: 0,
    signaturefiles: 0,
    receivedQueryMailsTotal: 0,
  });

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const { role_id = "", userId = "", roleType = "", user_grade = "", e_grade = "", r_grade = "", my_branchs = "" } = user;
  const isAdmin = role_id === "1" || role_id === "2";

  useEffect(() => {
    fetchData();
    return () => clearInterval(state.interval);
  }, []);

  const fetchData = async () => {
    try {
      await Promise.all([
        getPageDynamicData(),
        getFilesqueue(),
        getFiles(1, 20),
        getDVerifiedFiles(1, 20),
        getDeviationFilesqueue(),
        getRectificationFilesqueue(),
        getSignatureFilesqueue(),
        getFinalApprovalFilesqueue(),
        getReceivedQueryMailCount(),
      ]);
    } catch (err) {
      console.error(err);
    }
  };

  const getFilesqueue = async () => {
    const response = await callApi("POST", "get_by_status.php", {
      status: 0,
      userId,
      user_grade,
    });
    const files = response.data.data;
    const currentDate = new Date();
    const newFilesMoreThan20 = [];
    const newFilesLessThan20 = [];
    let file_grade = [];

    files.forEach((file) => {
      if (file.file_grade === "E" && ["0", "1", "2", "8"].includes(file.file_status)) {
        file_grade.push(file);
      }
      const [date, time] = file.date_time.split("/");
      const [day, month, year] = date.split("-");
      const [hour, minute] = time.split(":");
      const fileDate = new Date(year, month - 1, day, hour, minute);
      const timeDiff = Math.floor((currentDate - fileDate) / (1000 * 60));

      if (timeDiff >= 20 && file.file_grade !== "E") {
        newFilesMoreThan20.push(file);
      } else if (timeDiff <= 20 && file.file_grade !== "E") {
        newFilesLessThan20.push(file);
      }
    });

    setState((prev) => ({
      ...prev,
      waiting_queue_count: newFilesMoreThan20.length,
      queue_count: newFilesLessThan20.length,
      file_grade: file_grade.length,
    }));
  };

  const getFiles = async (page_id, row_count) => {
    const response = await callApi("POST", "get_by_status.php", {
      status: 6,
      userId,
      page_id,
      row_count,
    });
    setState((prev) => ({
      ...prev,
      verifyEmergentCount: response.data.countEmergent ?? "0",
      verifyNormalFile: response.data.countNormal ?? "0",
    }));
  };

  const getDVerifiedFiles = async (page_id, row_count) => {
    const response = await callApi("POST", "get_by_status.php", {
      status: 12,
      userId,
      page_id,
      row_count,
    });
    setState((prev) => ({
      ...prev,
      dverifyEmergentCount: response.data.countDVEmergent ?? "0",
      dverifyNormalFile: response.data.countDVNormal ?? "0",
    }));
  };

  const getDeviationFilesqueue = async () => {
    const response = await callApi("POST", "get_deviation_files.php", { userId });
    processFiles(response.data.data, "deviationfiles", "deviationemergentFile");
  };

  const getRectificationFilesqueue = async () => {
    const response = await callApi("POST", "get_rectify_files.php", { userId });
    processFiles(response.data.data, "rectificationfiles", "rectificationemergentFile");
  };

  const getFinalApprovalFilesqueue = async () => {
    const response = await callApi("POST", "get_by_status.php", {
      status: 15,
      final_approval_status: 1,
      userId
    });
    setState((prev) => ({
      ...prev,
      finalApprovalEmergentCount: response.data.countFAEmergent ?? "0",
      finalApprovalNormalFile: response.data.countFANormal ?? "0",
    }));
  };

  const getSignatureFilesqueue = () => {
    const user = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    let req = {
      userId: userId
    }
    callApi("POST", "get_sign_pending_files.php", req)
      .then((res) => res.data)
      .then((response) => {
        if (response.status == true) {
          setState((prev) => ({
            ...prev,
            signaturefiles: response.responseJson.totalRecords ?? "0",
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const processFiles = (files, normalKey, emergentKey) => {
    const emergentFiles = [];
    const normalFiles = [];

    files.forEach((file, index) => {
      Object.keys(file).forEach((key) => {
        file[key] = file[key] ? String(file[key]) : "";
      });
      file.index = index + 1;
      if (file.file_grade === "E") {
        emergentFiles.push(file);
      } else {
        normalFiles.push(file);
      }
    });

    setState((prev) => ({
      ...prev,
      [normalKey]: normalFiles.length,
      [emergentKey]: emergentFiles.length,
    }));
  };

  const getPageDynamicData = async () => {
    const response = await callApi("POST", "authenticating_pages_list_new.php", {
      roleId: user.role_id,
      userId,
      roleType,
    });
    const pageDynamicData = response?.data?.responseJson?.data;
    setState((prev) => ({
      ...prev,
      pageDynamic: Array.isArray(pageDynamicData) ? pageDynamicData : [],
      is_thread_mail_enabled: response?.data?.responseJson?.is_thread_mail_enabled,
    }));
  };

  const getReceivedQueryMailCount = async () => {
    const branch_ids = my_branchs.split(",");
    try {
      const response = await callApi("POST", "fetch_query_received_mail_details.php", {
        action: "get_status7_files_with_mails",
        branch_id: branch_ids,
        page: 1,
        limit: 100,
      });
      const data = response?.data;
      if (data && data.success && typeof data.total_files !== "undefined") {
        setState((prev) => ({ ...prev, receivedQueryMailsTotal: data.total_files }));
      }
    } catch (err) {
      console.error("getReceivedQueryMailCount", err);
    }
  };

  const getExternalLinks = async () => {
    const response = await callApi("GET", "get_external_link.php");
    setState((prev) => ({ ...prev, externalLinks: response.data.data }));
  };

  const toggleMenu = (key) => {
    if (key === "openExternalMenu") getExternalLinks();
    setState((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const path =
    roleType === "16"
      ? "/deviation-dashboard"
      : roleType === "23"
        ? "/double-verification-inprogress" :
        roleType === "17"
          ? "/rectify-dashboard"
          : role_id === "3"
            ? "/executive-dashboard"
            : "/dashboard";

  const predefinedOrder = ["Login Files", "Unassigned Files", "Work In Progress", "Query Validation Work In Progress", "Assigned Files", "Query Raised Files", "Query Received Files", "Process Completed Files", "Your Verification Files", "Hold", "UnHold", "Double Verification Queue", "Double Verification Work InProgress", "Final Approval Queue", "Final Approval Inprogress", "Completed Files", "Deviation Queue", "Deviation InProgress", "Rectification Queue", "Rectification InProgress", "File Logs", "Signature", "Signature Queue", "Signature InProgress"];
  const pageDynamicList = Array.isArray(state?.pageDynamic) ? state.pageDynamic : [];
  const sortedPages = pageDynamicList.slice().sort(
    (a, b) => predefinedOrder?.indexOf(a?.page_name) - predefinedOrder?.indexOf(b?.page_name)
  );

  const isSendNoticeAccess = pageDynamicList.find((page) => page.page_name === "Send Notice" && page.status == true);

  return (
    <nav className="pcoded-navbar menupos-fixed">
      <div className="navbar-wrapper">
        <div className="navbar-brand header-logo">
          <a className="b-brand">
            <div className="b-bg">L</div>
            <span className="b-title">Law Hands</span>
          </a>
        </div>
        <div className="navbar-content scroll-div style-sidebar">
          <ul className="nav pcoded-inner-navbar">
            <li className="nav-item">
              <NavLink to={path}>
                <span className="pcoded-micon">
                  <i className="feather icon-home" />
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </NavLink>
            </li>
            <li className="nav-item pcoded-hasmenu">
              <a onClick={() => toggleMenu("openFileMenu")}>
                <span className="pcoded-micon">
                  <i className="feather icon-server" />
                </span>
                <span className="pcoded-mtext">File Management</span>
              </a>
              {state.openFileMenu && (
                <ul className="pcoded-submenu">
                  {sortedPages && sortedPages?.map((page, index) => {
                    const autoAssign = state.autoAssign.find(
                      (data) => data.module_name === "Auto Assign" && data.status
                    );
                    const menuItems = {
                      "Login Files": { path: "/pending-file", label: page.page_name },
                      "Unassigned Files": {
                        path: "/unassigned-file",
                        label: autoAssign ? "Queue" : page.page_name,
                        badge: autoAssign && (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.queue_count}</span>
                            <span className="queue-waiting-badge">{state.waiting_queue_count}</span>
                            {e_grade === "E" && (
                              <span className="emergent-count-badge">{state.file_grade}</span>
                            )}
                          </div>
                        ),
                      },
                      "Process Completed Files": {
                        path: "/to-be-verified-file",
                        label: autoAssign ? "Verification Queue" : page.page_name,
                        badge: autoAssign && (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.verifyNormalFile}</span>
                            {e_grade === "E" && (
                              <span className="emergent-count-badge">{state.verifyEmergentCount}</span>
                            )}
                          </div>
                        ),
                      },
                      "Double Verification Queue": {
                        path: "/double-verification-queue",
                        label: page.page_name,
                        badge: autoAssign && (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.dverifyNormalFile}</span>
                            {e_grade === "E" && (
                              <span className="emergent-count-badge">{state.dverifyEmergentCount}</span>
                            )}
                          </div>
                        ),
                      },
                      "Double Verification Work InProgress": { path: "/double-verification-inprogress", label: page.page_name },
                      "Assigned Files": { path: "/assigned-file", label: page.page_name },
                      "Work In Progress": { path: "/inprogress-file", label: page.page_name },
                      "Query Validation Work In Progress": { path: "/query-validation-inprogress", label: page.page_name },
                      "Query Raised Files": { path: "/query-raised-files", label: page.page_name },
                      "Query Received Files": { path: "/query-received-files", label: page.page_name },
                      "Your Verification Files": { path: "/to-user-verified-file", label: page.page_name },
                      Hold: { path: "/hold-file", label: page.page_name },
                      UnHold: { path: "/unhold-file", label: page.page_name },
                      "Completed Files": {
                        submenu: (
                          <li className="nav-item pcoded-hasmenu">
                            <a onClick={() => toggleMenu("toggleCompletedFiles")}>
                              <span className="pcoded-mtext">Completed Files</span>
                            </a>
                            {state.toggleCompletedFiles && (
                              <ul className="pcoded-submenu">
                                <li>
                                  <NavLink to="/typing-completed" activeClassName="active">
                                    Typing Completed
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/completed-file" activeClassName="active">
                                    Verify Completed
                                  </NavLink>
                                </li>
                              </ul>
                            )}
                          </li>
                        ),
                      },
                      Signature: { path: "/signature-file/search", label: page.page_name },
                      "File Logs": { path: "/file-log", label: page.page_name },
                      "Deviation Queue": {
                        path: "/deviation-queue",
                        label: page.page_name,
                        badge: (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.deviationfiles}</span>
                            {e_grade === "E" && (
                              <span className="emergent-count-badge">{state.deviationemergentFile}</span>
                            )}
                          </div>
                        ),
                      },
                      "Deviation InProgress": { path: "/deviation-work-inprogress", label: page.page_name },
                      "Rectification Queue": {
                        path: "/rectification-queue",
                        label: page.page_name,
                        badge: r_grade === "R" && (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.rectificationfiles}</span>
                            <span className="emergent-count-badge">{state.rectificationemergentFile}</span>
                          </div>
                        ),
                      },
                      "Rectification InProgress": { path: "/rectification-work-inprogress", label: page.page_name },
                      "Signature Queue": {
                        path: "/signature-queue",
                        label: page.page_name,
                        badge: (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.signaturefiles}</span>
                          </div>
                        ),
                      },
                      "Signature InProgress": { path: "/signature-work-inprogress", label: page.page_name },
                      "Final Approval Queue": {
                        path: "/final-approval-queue",
                        label: page.page_name,
                        badge: autoAssign && (
                          <div style={{ marginTop: "3%" }}>
                            <span className="queue-badge">{state.finalApprovalNormalFile}</span>
                            {e_grade === "E" && (
                              <span className="emergent-count-badge">{state.finalApprovalEmergentCount}</span>
                            )}
                          </div>
                        ),
                      },
                      "Final Approval Inprogress": { path: "/final-approval-inprogress", label: page.page_name },
                    };

                    const item = menuItems[page.page_name];
                    if (item && page.status) {
                      return item.submenu || (
                        <li key={index} style={{ display: "flex" }}>
                          <NavLink to={item.path} activeClassName="active">
                            {item.label}
                          </NavLink>
                          {item.badge}
                        </li>
                      );
                    }
                    return null;
                  })}
                </ul>
              )}
            </li>
            {pageDynamicList.map((page, index) => {
              if (
                state.is_thread_mail_enabled &&
                page.page_name === "Received Query Mails" &&
                page.status == true
              ) {
                return (
                  <li key={index} className="nav-item" style={{ display: "flex" }}>
                    <NavLink to="/received-query-mails">
                      <span className="pcoded-micon">
                        <i className="feather icon-mail" />
                      </span>
                      <span className="pcoded-mtext">Received Query Mails</span>
                    </NavLink>
                    <div style={{ marginTop: "6%" }}>
                      <span className="queue-badge">{state.receivedQueryMailsTotal}</span>
                    </div>
                  </li>
                );
              }
              return null;
            })}
            <li className="nav-item pcoded-hasmenu">
              <a onClick={() => toggleMenu("toggleVettingFiles")}>
                <span className="pcoded-micon">
                  <i className="feather icon-server" />
                </span>
                <span className="pcoded-mtext">Vetting Management</span>
              </a>
              {state.toggleVettingFiles && (
                <ul className="pcoded-submenu">
                  {[
                    { path: "/vetting-login", label: "Login Files" },
                    { path: "/vetting-queue", label: "Queue Files" },
                    { path: "/vetting-process", label: "Work Inprogress" },
                    { path: "/vetting-complete", label: "Completed Files" },
                    { path: "/vetting-hold", label: "Hold Files" },
                    { path: "/vetting-unhold", label: "UnHold Files" },
                  ].map(({ path, label }) => (
                    <li key={path}>
                      <NavLink to={path} activeClassName="active">
                        {label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li className="nav-item">
              <NavLink to="/entry-tracking-report">
                <span className="pcoded-micon">
                  <i className="feather icon-file-text" />
                </span>
                <span className="pcoded-mtext">Entry Tracking Report</span>
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink to="/tat-tracking">
                <span className="pcoded-micon">
                  <i className="feather icon-clock" />
                </span>
                <span className="pcoded-mtext">TAT Tracking</span>
              </NavLink>
            </li> */}
            {pageDynamicList
              ?.filter(page => page?.page_name === "Process Officer Eod" && page?.status === true)
              .map((page, index) => (
                <li className="nav-item" key={index}>
                  <NavLink to="/process-eod">
                    <span className="pcoded-micon">
                      <i className="feather icon-file-text" />
                    </span>
                    <span className="pcoded-mtext">Process Officer Eod</span>
                  </NavLink>
                </li>
              ))
            }
            <li className="nav-item">
              <NavLink to="/eod-report">
                <span className="pcoded-micon">
                  <i className="feather icon-file-text" />
                </span>
                <span className="pcoded-mtext">Verification Eod</span>
              </NavLink>
            </li>
            {/* {role_id !== FRONTOFFICE_ROLE && ( */}
            < li className="nav-item pcoded-hasmenu" >
              <a onClick={() => toggleMenu("openReportsMenu")}>
                <span className="pcoded-micon">
                  <i className="feather icon-file-text" />
                </span>
                <span className="pcoded-mtext">Reports</span>
              </a>
              {state.openReportsMenu && (
                <ul className="pcoded-submenu">
                  {pageDynamicList.map((page, index) => {
                    const reportItems = {
                      "GOLM Report": { path: "/golm-report" },
                      "Deviation Report": { path: "/Deviationreport-report" },
                      "File Completed Report": { path: "/filecompleted-report" },
                      "vetting Report": { path: "/vettingcomplete" },
                      "Law Hands MIS": { path: "/lawhandsMisreport" },
                      "Emergent Report": { path: "/emergentreport" },
                      "Reassign Report": { path: "/reassign-report" },
                      "Video Report": { path: "/videoreport" },
                      "Express Report": { path: "/express-report" },
                      "Queue Report": { path: "/queue-report" },
                      "Final Approve Report": { path: "/final_approve-report" },
                      "System Verification Report": { path: "/ai-verification-report" },
                    };
                    const item = reportItems[page.page_name];
                    if (item && page.status) {
                      return (
                        <li key={index}>
                          <NavLink to={item.path} activeClassName="active">
                            {page.page_name}
                          </NavLink>
                        </li>
                      );
                    }
                    return null;
                  })}
                  {role_id === "3" && (
                    <li>
                      <NavLink to="/dashboard" activeClassName="active">
                        Dashboard
                      </NavLink>
                    </li>
                  )}
                </ul>
              )}
            </li>
            {/* )} */}
            {/* <li className="nav-item">
              <NavLink to="/query">
                <span className="pcoded-micon">
                  <i className="feather icon-file-text" />
                </span>
                <span className="pcoded-mtext">Query</span>
              </NavLink>
            </li> */}
            {pageDynamicList.map((page, index) =>
              page.page_name === "Global Search" && page.status ? (
                <li className="nav-item" key={index}>
                  <NavLink to="/branch-search">
                    <span className="pcoded-micon">
                      <i className="feather icon-search" />
                    </span>
                    <span className="pcoded-mtext">Global Search</span>
                  </NavLink>
                </li>
              ) : null
            )}
            {role_id !== FRONTOFFICE_ROLE && (
              <li className="nav-item pcoded-hasmenu">
                <a onClick={() => toggleMenu("openExternalMenu")}>
                  <span className="pcoded-micon">
                    <i className="feather icon-link-2" />
                  </span>
                  <span className="pcoded-mtext">External References</span>
                </a>
                {state.openExternalMenu && (
                  <ul className="pcoded-submenu">
                    {state.externalLinks.length > 0 ? (
                      state.externalLinks.map((extLink, extIndex) => (
                        <li key={extIndex} className="nav-item">
                          <a href={extLink.link} target="_blank">
                            <i className="feather icon-external-link"> {extLink.name}</i>
                          </a>
                        </li>
                      ))
                    ) : (
                      <li>No Links Found</li>
                    )}
                  </ul>
                )}
              </li>
            )}
            <li className="nav-item pcoded-hasmenu">
              <a onClick={() => toggleMenu("openComplaintMenu")}>
                <span className="pcoded-micon">
                  <i className="feather icon-server" />
                </span>
                <span className="pcoded-mtext">Complaint Box</span>
              </a>
              {state.openComplaintMenu && (
                <ul className="pcoded-submenu">
                  <li>
                    <NavLink to="/register-complaint" activeClassName="active">
                      Register Complaint
                    </NavLink>
                  </li>
                  {["1", "242", "401", "572"].includes(userId) && (
                    <li>
                      <NavLink to="/all-complaints" activeClassName="active">
                        Complaint List
                      </NavLink>
                    </li>
                  )}
                </ul>
              )}
            </li>
            <li className="nav-item pcoded-hasmenu">
              <a onClick={() => toggleMenu("openNotificationMenu")}>
                <span className="pcoded-micon">
                  <i className="feather icon-server" />
                </span>
                <span className="pcoded-mtext">Notice Board</span>
              </a>
              {state.openNotificationMenu && (
                <ul className="pcoded-submenu">
                  {isSendNoticeAccess && (
                    <li>
                      <NavLink to="/notification/add" activeClassName="active">
                        Send Notice
                      </NavLink>
                    </li>
                  )}
                  {isAdmin && (
                    <li>
                      <NavLink to="/livetracking" activeClassName="active">
                        Live Track
                      </NavLink>
                    </li>
                  )}
                  <li>
                    <NavLink to="/all-notifications" activeClassName="active">
                      Notice List
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
            {role_id === FRONTOFFICE_ROLE && (
              <li className="nav-item pcoded-hasmenu">
                <a onClick={() => toggleMenu("openVisitorsMenu")}>
                  <span className="pcoded-micon">
                    <i className="feather icon-server" />
                  </span>
                  <span className="pcoded-mtext">Visitor</span>
                </a>
                {state.openVisitorsMenu && (
                  <ul className="pcoded-submenu">
                    <li>
                      <NavLink to="/visitor/add/" activeClassName="active">
                        Add New Visitor
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/visitor-list" activeClassName="active">
                        Visitor's List
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav >
  );
};

export default Sidebar;